var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    _vm.$style.button,
    _vm.small && _vm.$style.small,
    _vm.transparent && _vm.$style.transparent,
    _vm.back && _vm.$style.back,
    _vm.grayscale && _vm.$style.grayscale,
  ],attrs:{"disabled":_vm.disabled,"type":_vm.type}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }